export default __webpack_public_path__ + "static/media/02-doc.376a3e8e.mp4";